<template>
  <NavBar pageName="Manual Platforma"></NavBar>
  <div class="manual-container">
    <iframe
      src="/platform-documentation.html"
      class="manual-iframe"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  components: { NavBar }
};
</script>

<style scoped>
.manual-container {
  position: fixed;
  top: 135px;
  left: 0;
  right: 0;
  bottom: 0;
}

.manual-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
